import { render } from "./FormSection.vue?vue&type=template&id=6eb0d406"
import script from "./FormSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/FormSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eb0d406"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eb0d406', __exports__)) {
    api.reload('6eb0d406', __exports__)
  }
  
  module.hot.accept("./FormSection.vue?vue&type=template&id=6eb0d406", () => {
    api.rerender('6eb0d406', render)
  })

}


export default __exports__